import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Memories", path: "/memories" },
  {
    name: "Info",
    dropdown: [
      { name: "Tech Tips", path: "/techtips" },
      { name: "Certificates", path: "/certificates" },
      { name: "Contact", path: "/contact" },
      { name: "Remembering Bob Belfi", path: "/remembering-bob-belfi" },
    ],
  },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const location = useLocation();

  const handleDropdown = (idx) => {
    setDropdownOpen(dropdownOpen === idx ? null : idx);
  };

  return (
    <header className="rtc-header">
      <nav className="rtc-header-nav">
        {/* Logo */}
        <Link to="/" className="rtc-header-logo">
          <img
            src="/Assets/og-logo.png"
            alt="Rolling Thunder Cycles logo"
            className="rtc-header-logo-img"
          />
          <span className="rtc-header-logo-text">Rolling Thunder Cycles</span>
        </Link>

        {/* Hamburger for mobile */}
        <button
          onClick={() => setMenuOpen((v) => !v)}
          className="rtc-header-hamburger nav-hamburger"
          aria-label="Toggle navigation"
        >
          ☰
        </button>

        {/* Navigation Links */}
        <ul
          className={`rtc-header-nav-links nav-links${menuOpen ? " open" : ""}`}
        >
          {navLinks.map((link, idx) =>
            !link.dropdown ? (
              <li key={link.name}>
                <Link
                  to={link.path}
                  className={
                    "rtc-header-nav-link" +
                    (location.pathname === link.path ? " active" : "")
                  }
                  onClick={() => setMenuOpen(false)}
                >
                  {link.name}
                </Link>
              </li>
            ) : (
              <li
                key={link.name}
                className="rtc-header-dropdown"
                onMouseEnter={() => setDropdownOpen(idx)}
                onMouseLeave={() => setDropdownOpen(null)}
              >
                <button
                  className={
                    "rtc-header-nav-link rtc-header-dropdown-btn" +
                    (dropdownOpen === idx ? " active" : "")
                  }
                  aria-haspopup="true"
                  aria-expanded={dropdownOpen === idx}
                  onClick={() => handleDropdown(idx)}
                  type="button"
                >
                  {link.name}{" "}
                  <span className="rtc-header-dropdown-arrow">▼</span>
                </button>
                <ul
                  className={`rtc-header-dropdown-menu${
                    dropdownOpen === idx ? " open" : ""
                  }`}
                >
                  {link.dropdown.map((item) => (
                    <li key={item.name}>
                      <Link
                        to={item.path}
                        className={
                          "rtc-header-nav-link" +
                          (location.pathname === item.path ? " active" : "")
                        }
                        onClick={() => {
                          setMenuOpen(false);
                          setDropdownOpen(null);
                        }}
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            ),
          )}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
